<template>
  <div>
    <Layout>
      <router-view class="view-box" />

      <div v-if="showLazyLoader">
        <div class="simplepharm-modal">
          <div class="simplepharm-modal-content" style="width: 550px">
            <div>{{ lazyloaderModule.getProgressBarMessage }}</div>
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            <div v-if="lazyloaderModule.displayProgressBar" style="width: 100%">
              <b-progress
                :value="lazyloaderModule.getProgressBarProgress"
                :max="100"
                class="mb-4"
                variant="info"
                animated
              ></b-progress>
              {{ progressPercentage }}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from "../../layouts/main";
import { useSimplepharmAuthModule } from "@/state/pinia/simplepharmAuthModule";
import { useCommonAppModule, useLazyLoaderModule } from "@/state/pinia";

export default {
  name: "UserCommonManagerView",
  components: {
    Layout,
  },
  data() {
    return {
      showLazyLoader: false,
      progressPercentage: "1%",
      progressPollAttempts: 0,
      maxProgressPollAttempts: 120,
    };
  },
  methods: {
    observeProgressUntilDoneRecursively() {
      if (this.progressPollAttempts >= this.maxProgressPollAttempts) {
        return;
      }
      this.progressPollAttempts += 1;
      const taskProgressRequest = {
        taskId: this.processGUID,
      };

      this.commonModule.httpGetProcessProgressStatus(taskProgressRequest).then(() => {
        if (this.lazyloaderModule.getProgressBarProgress < 100) {
          this.observeProgressUntilDoneRecursively();
        } else {
          this.progressPollAttempts = 0;
        }
      });
    },
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    displayLazyLoader() {
      return this.lazyloaderModule.displayLazyLoader;
    },
    progressBarProgress() {
      return this.lazyloaderModule.getProgressBarProgress;
    },
    processGUID() {
      return this.commonModule.getProcessGUID;
    },
  },
  watch: {
    displayLazyLoader: {
      handler(newVal) {
        this.showLazyLoader = newVal;
      },
      deep: true,
    },
    progressBarProgress: {
      handler(newVal) {
        const calculatedPercentageProgress = Number(newVal) || 0;
        this.progressPercentage = Math.round(calculatedPercentageProgress) + "%";
      },
      deep: true,
    },
    processGUID: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && newVal.length > 0) {
          this.progressPollAttempts = 0;
          this.observeProgressUntilDoneRecursively();
        }
      },
      deep: true,
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>
